let listingData = {
  columns: [
    "User ID",
    "Date and time of the impact",
    "Location",
    "Report status",
  ],
  columnsItems: ["user_id", "crash_timestamp", "location", "status"],
  dropdownHour: [
    "0 hr",
    "1 hr",
    "2 hr",
    "3 hr",
    "4 hr",
    "5 hr",
    "6 hr",
    "7 hr",
    "8 hr",
    "9 hr",
    "10 hr",
    "11 hr",
    "12 hr",
    "13 hr",
    "14 hr",
    "15 hr",
    "16 hr",
    "17 hr",
    "18 hr",
    "19 hr",
    "20 hr",
    "21 hr",
    "22 hr",
    "23 hr",
  ],
  dropdownMin: [
    "0 min",
    "1 min",
    "2 min",
    "3 min",
    "4 min",
    "5 min",
    "6 min",
    "7 min",
    "8 min",
    "9 min",
    "10 min",
    "11 min",
    "12 min",
    "13 min",
    "14 min",
    "15 min",
    "16 min",
    "17 min",
    "18 min",
    "19 min",
    "20 min",
    "21 min",
    "22 min",
    "23 min",
    "24 min",
    "37 min",
    "38 min",
    "39 min",
    "40 min",
    "41 min",
    "42 min",
    "43 min",
    "44 min",
    "45 min",
    "46 min",
    "47 min",
    "48 min",
    "49 min",
    "50 min",
    "51 min",
    "52 min",
    "53 min",
    "54 min",
    "55 min",
    "56 min",
    "57 min",
    "58 min",
    "59 min",
  ],
};
const reportData={
  itemMaps: [
    {
      image: "break.png",
      text: "Braking",
    },
    {
      image: "acceleration.png",
      text: "Acceleration",
    },
    {
      image: "speeding.png",
      text: "Speeding",
    },
    {
      image: "phone-handling.png",
      text: "Phone handling",
    },
  ],
}
export { listingData, reportData };
